<section class="form_section">
    <!--<div class="dialog-header">
      <button mat-icon-button (click)="cerrarDialogo()">
        <mat-icon>close</mat-icon>
      </button>
    </div>-->
    <h2>Actualizar Dato de Contacto</h2>
    
    <!-- Formulario Email -->
    <form
      *ngIf="type==='email'"
      class="form_register_minutes"
      [formGroup]="formEmail"
      (ngSubmit)="submitFormEmail()"
    >
      <section class="container-form">
        <mat-form-field class="example-form-field">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email"/>
        </mat-form-field>
        <div *ngIf="formEmail.controls['email'].errors?.['emailInvalid'] && formEmail.controls['email'].touched">
          El Email es Invalido.
        </div>
      </section>
      <section class="button_class">
        <button
          [disabled]="!formEmail.valid"
          mat-stroked-button
          color="primary"
          type="submit"
          class="w-50"
        >
          Actualizar
        </button>
      </section>
    </form>
  
    <!-- Formulario Telefono -->
    <form
      *ngIf="type==='telefono'"
      class="form_register_minutes"
      [formGroup]="formTelefono"
      (ngSubmit)="submitFormTelefono()"
    >
      <section class="container-form">
        <mat-form-field class="example-form-field">
          <mat-label>Telefono</mat-label>
          <input matInput type="number" formControlName="telefono"/>
        </mat-form-field>
        <div *ngIf="formTelefono.controls['telefono'].errors?.['minlength'] && formTelefono.controls['telefono'].touched">
          Telefono Invalido.
        </div>
      </section>
      <section class="button_class">
        <button
          [disabled]="!formTelefono.valid"
          mat-stroked-button
          color="primary"
          type="submit"
          class="w-50"
        >
          Actualizar
        </button>
      </section>
    </form>
  </section>
  